export const referralConstant = {
    GET_REFERRAL_SETTING: 'GET_REFERRAL_SETTING',
    GET_ALL_REFERRAL_SETTINGS: 'GET_ALL_REFERRAL_SETTINGS',
    GET_REFERRAL_TYPE_ENABLED: 'GET_REFERRAL_TYPE_ENABLED',
    GET_REFERRAL_MULTITIER: 'GET_REFERRAL_MULTITIER',
    GET_REFERRAL_BONUS_ANNOUNCEMENT: 'GET_REFERRAL_BONUS_ANNOUNCEMENT',
};
